import { IProps as IFormFieldCheckbox } from '../../FormFieldCheckbox'
import { IProps as IFormFieldEmail } from '../../FormFieldEmail'
import { IProps as IFormFieldHidden } from '../../FormFieldHidden'
import { IProps as IFormFieldInput } from '../../FormFieldInput'
import { IProps as IFormFieldNumber } from '../../FormFieldNumber'
import { IProps as IFormFieldPhone } from '../../FormFieldPhone'
import { IProps as IFormFieldRadioButtons } from '../../FormFieldRadioButtons'
import { IProps as IFormFieldSelect } from '../../FormFieldSelect'
import { IProps as IFormFieldTextarea } from '../../FormFieldTextarea'
import { IAutoFill } from './AutoFill'

export type IFormField =
  | IFormFieldCheckbox
  | IFormFieldEmail
  | IFormFieldHidden
  | IFormFieldInput
  | IFormFieldNumber
  | IFormFieldHTMLText
  | IFormFieldPhone
  | IFormFieldRadioButtons
  | IFormFieldSelect
  | IFormFieldTextarea

export enum FieldType {
  CHECKBOX = 'checkbox',
  EMAIL = 'email',
  HIDDEN = 'hidden',
  HTML_TEXT = 'htmltext',
  NUMBER = 'number',
  PHONE = 'telephone',
  RADIO_BUTTONS = 'radioButtons',
  SELECT = 'select',
  TEXT = 'text',
  TEXTAREA = 'textArea',
}

interface IFormFieldBase {
  id: string
  size?: 'large' | 'small'
  required?: boolean
  autoFill?: IAutoFill
}

export interface IFieldValue {
  label: string
  value: string
}

export interface IFormFieldHTMLText extends IFormFieldBase {
  type: 'htmltext'
  text: string
  isDisabled?: boolean
}

export const isCheckboxField = (field: IFormField): field is IFormFieldCheckbox => {
  return field.type === FieldType.CHECKBOX
}

export const isEmailField = (field: IFormField): field is IFormFieldEmail => {
  return field.type === FieldType.EMAIL
}

export const isHiddenField = (field: IFormField): field is IFormFieldHidden => {
  return field.type === FieldType.HIDDEN
}

export const isHtmlTextField = (field: IFormField): field is IFormFieldHTMLText => {
  return field.type === FieldType.HTML_TEXT
}

export const isNumberField = (field: IFormField): field is IFormFieldNumber => {
  return field.type === FieldType.NUMBER
}

export const isRadioButtonsField = (field: IFormField): field is IFormFieldRadioButtons => {
  return field.type === FieldType.RADIO_BUTTONS
}

export const isSelectField = (field: IFormField): field is IFormFieldSelect => {
  return field.type === FieldType.SELECT
}

export const isTextField = (field: IFormField): field is IFormFieldInput => {
  return field.type === FieldType.TEXT
}

export const isTextareaField = (field: IFormField): field is IFormFieldTextarea => {
  return field.type === FieldType.TEXTAREA
}
